import Vue from 'vue';

const StepperBus = new Vue();

export default StepperBus;
